export default [{
        path: '/comic_details',
        component: resolve => require(['../../../../view/find/Comic/comic_details/comic_details.vue'], resolve),

    }, {
        path: '/comic_list',
        component: resolve => require(['../../../../view/find/Comic/comic_details/subclass/comic_list.vue'], resolve),
    },
    {
        path: '/comic_checkmore',
        component: resolve => require(['../../../../view/find/Comic/subclass/more.vue'], resolve),
    },
    {
        path: '/comic_classification',
        component: resolve => require(['../../../../view/find/Comic/subclass/comic_classification.vue'], resolve),
    },
    {
        path: '/comic_search',
        component: resolve => require(['../../../../view/find/Comic/subclass/comic_search.vue'], resolve),
    },

]


// WEBPACK FOOTER //
// ./src/router/find/comic/comic_details/index.js